// Apple iOS/macOS design tokens shared across all template components
// NOTE: Active/accent colors use CRM green (#00AB55), not Apple blue
export const APPLE = {
  accent: '#00AB55',
  accentHover: '#007B55',
  accentLight: 'rgba(0,171,85,0.06)',
  blue: '#007AFF',
  blueHover: '#0066D6',
  green: '#34C759',
  red: '#FF3B30',
  orange: '#FF9500',
  grayBg: '#f5f5f7',
  grayText: '#86868b',
  grayBorder: '#d2d2d7',
  cardRadius: '14px',
  inputRadius: '10px',
  segmentedRadius: '9px',
  shadow: '0 1px 4px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)',
  shadowMd: '0 4px 12px rgba(0,0,0,0.08), 0 1px 3px rgba(0,0,0,0.06)',
  shadowHover: '0 8px 24px rgba(0,0,0,0.12), 0 2px 6px rgba(0,0,0,0.06)',
  font: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', 'SF Pro Text', sans-serif",
};

// Reusable sx props for Apple-style inputs
export const appleInputSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: APPLE.inputRadius,
    bgcolor: APPLE.grayBg,
    fontFamily: APPLE.font,
    transition: 'all 0.2s ease',
    '& fieldset': { borderColor: 'transparent' },
    '&:hover fieldset': { borderColor: APPLE.grayBorder },
    '&.Mui-focused fieldset': { borderColor: APPLE.accent, borderWidth: '2px' },
    '&.Mui-focused': { bgcolor: '#fff' },
  },
};

